export const SUPABASE_FROSH_URL = ["https://jdcymsopfpnaklhdcigk.supabase.co"];
export const SUPABASE_BLOG_URL = "https://rnpcsynkfxzorrreypqf.supabase.co";
